export default "https://cdn-static.gokick.com/assets/ed6531e95fd3f911890bedfaed34e81f4e5a2128/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";